<script setup>
import CoreButton from '@/Components/Button/CoreButton.vue';

defineProps({
  type: {
    type: String,
    default: 'submit'
  },
  size: {
    type: String,
    default: 'medium'
  },
  isLoading: {
    type: Boolean
  },
  datadogActionName: {
    type: String,
    default: null
  }
});
</script>

<template>
  <CoreButton
    :type="type"
    :size="size"
    :is-loading="isLoading"
    :datadog-action-name="datadogActionName"
    class="text-outlined-button-content ring-outlined-button-content bg-transparent ring-1"
  >
    <slot />
  </CoreButton>
</template>
